import request from "@/utils/request";

// 获取所有省份列表
export function getProvinces(data) {
  return request({
    url: "/prov-entrance/front/list",
    method: "get",
    data,
  });
}
// 获取各省入口详情
export function getProvincesDetail(params) {
  return request({
    url: "/prov-entrance/front/info",
    method: "get",
    params,
  });
}
// 获取各省入口详情
export function getHotQuestions(params) {
  return request({
    url: "/problem/hot",
    method: "get",
    params,
  });
}

// 获取文章内容详情
export function getArticleDetail(contentMetaId) {
  return request({
    url: `/content-meta/front/${contentMetaId}/detail`,
    method: "post",
  });
}

// 获取服务指南tab按钮
export function getServiceTabs(params) {
  return request({
    url: `/content-type/tree`,
    method: "get",
    params,
  });
}

// 获取用户临时授权token

export function getTempToken(data) {
  return request({
    url: `/chzz-user/access-token/temp`,
    method: "post",
    data,
  });
}


